export default __webpack_public_path__ + "static/media/newOrder.37756ebb.mp3";